import { fetchOwnProfile } from '@/api/users'
import { VuexActionData } from '@/store'
import Vue from 'vue'
import { namespace } from 'vuex-class'
import { logout } from '~/api-shared/auth'

export const AuthStore = namespace('auth')

export interface AuthState {
    token_id: string
    authenticatedUser: IUser
}

export const authState = {
    token_id: null,
    authenticatedUser: null
} as AuthState

export const authGetters = {
    isAuthenticated: (state: AuthState) => state.token_id !== null
}

export const authMutations = {
    SET_AUTHENTICATED_USER: (state: AuthState, user: IUser) => (state.authenticatedUser = user),
    LOGIN: (state: AuthState, token: string) => {
        // token gets set in state and local storage
        state.token_id = token
        // sets axios to use token by default for every call
        Vue.$axios.defaults.headers.common.Authorization = `Token ${token}`
    },
    LOGOUT: (state: any) => {
        state.token_id = null
        Vue.$axios.defaults.headers.common.Authorization = ''
    }
}

export const authActions = {
    async onLoginSuccess({ commit, dispatch, getters }: VuexActionData<AuthState>, key: string) {
        // login the user locally
        commit('LOGIN', key)
        // fetch user info
        await dispatch('fetchOwnProfile')
        // redirect
        if (getters.isProducer) Vue.router.push({ name: 'ProducerDashboard' })
        else if (getters.isUploader) Vue.router.push({ name: 'BeatsCatalog' })
        else Vue.router.push({ name: 'Home' })
    },

    async logout({ commit }: VuexActionData<AuthState>) {
        await logout()
        commit('LOGOUT')
        window.location.href = ''
    },

    async fetchOwnProfile({ state, commit }: VuexActionData<AuthState>) {
        // set token to be used on all calls, if it's cached
        if (!state.token_id) return
        Vue.$axios.defaults.headers.common.Authorization = `Token ${state.token_id}`
        // make call, if it fails log out the user and delete token from caches
        try {
            const user = await fetchOwnProfile()
            commit('SET_AUTHENTICATED_USER', user)
        } catch (error) {
            commit('LOGOUT')
            commit('SET_AUTHENTICATED_USER', null)
        }
    }
}
